export default "__VITE_ASSET__ccff7395__"